import { CreditGroup as CreditGroupType, CreditTypeEnum } from '../../api/graphql/generated/schema';
import { CreditGroupItemDto } from './CreditGroupItemDto';
import { CalculationConfigDto } from '../finance/calculation/calculationConfig';

export class CreditGroupDto {
  private readonly _type: CreditTypeEnum;
  private _items: Array<CreditGroupItemDto>;
  private _creditCalculationParams?: CalculationConfigDto;

  constructor(type: CreditTypeEnum, items: Array<CreditGroupItemDto>, creditCalculationParams?: CalculationConfigDto) {
    this._type = type;
    this._items = items;
    this._creditCalculationParams = creditCalculationParams;
  }

  static convertFromCreditGroup(creditGroup: CreditGroupType) {
    let _items = creditGroup.items
      ? creditGroup.items.map((item) => CreditGroupItemDto.convertFromCreditGroupItem(item))
      : [];
    const creditCalculationParams = creditGroup.creditCalculationParams
      ? new CalculationConfigDto(creditGroup.creditCalculationParams)
      : undefined;
    return new CreditGroupDto(creditGroup.type, _items, creditCalculationParams);
  }

  get type(): CreditTypeEnum {
    return this._type;
  }

  get items(): Array<CreditGroupItemDto> {
    return this._items;
  }

  set items(value: Array<CreditGroupItemDto>) {
    this._items = value;
  }

  get creditCalculationParams(): CalculationConfigDto | undefined {
    return this._creditCalculationParams;
  }

  hasAnyInvalidItem() {
    return this._items && this._items.some((item) => !item.isValid());
  }
}
